//import library
import "lib/bootstrap-tagsinput/bootstrap-tagsinput.min.js";
import "lib/bootstrap-tagsinput/bootstrap-tagsinput.css";

export default {
  init(selector) {
    $(selector).tagsinput({
      tagClass: "label label-primary",
    });
  },
};
